import { getUserRegion, toTitleCase } from '../../../../utils';
import { payZone } from '../../form-components/ReactHookProducerFormSelects';
import Region from '../../../constants/region';

// eslint-disable-next-line import/prefer-default-export
export const getPayGroupDisplayName = (payGroup) => {
    const region = getUserRegion();

    if (region.includes('TCJ')) {
        return `$${payGroup.replace('_', '.')}`;
    }

    if (region.includes(Region.MMPA)) {
        const payGroupName = payZone(region)?.find(({ value }) => value === payGroup);
        return payGroupName?.name ?? payGroup;
    }

    return toTitleCase(payGroup, '_');
};
